export default "__VITE_ASSET__BrHF10zN__"